import axios from 'axios';

const { get, post } = axios;

export const getPathwayTemplate = pathwayTemplateId => get(`/v1/pathway_templates/${pathwayTemplateId}/`);
export const getPathwayTemplates = (params = {}) => get(`/v1/pathway_templates/`, { params });
export const getPathwayTemplateAnalysisResults = (pathwayTemplateId, analysisType, data = {}) =>
  post(`/v1/pathway_templates/${pathwayTemplateId}/${analysisType}/`, data);
